import { useEffect } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useConfig, useServices, useUrlLocation } from 'core/common/hooks';
import { redirectToUrl } from 'core/common/utils/redirectToUrl';

export const FAQ = () => {
  const config = useConfig();
  const { analyticsService } = useServices();
  const { previousLocation } = useUrlLocation();

  useEffect(() => {
    analyticsService.techPageOpened(BASE_ROUTES.TECH_FAQ, previousLocation);
    redirectToUrl(config.techLinks.faq);
  }, [config.techLinks.faq, analyticsService, previousLocation]);

  return null;
};
